import React from 'react';

export default function Contact() {
  return (
    <section id="contact" className="py-5" style={{ backgroundColor: '#f8fbfc', fontFamily: "'Montserrat', sans-serif" }}>
      <div className="container py-5">
        
        {/* Section Heading */}
        <div className="text-center mb-5">
          <span className="text-warning fw-bold text-uppercase" style={{ letterSpacing: '2px', fontSize: '14px' }}>
            Reach Out To Us
          </span>
          <h2 className="display-5 fw-bolder mt-2 mb-3" style={{ color: '#0f2b5b' }}>
            Let's Build a Sustainable Future
          </h2>
          <div className="bg-warning mx-auto rounded" style={{ width: '80px', height: '4px' }}></div>
        </div>

        {/* Contact Card */}
        <div className="card border-0 shadow-lg overflow-hidden" style={{ borderRadius: '2rem' }}>
          <div className="row g-0">
            
            {/* Contact Details (Left Side) */}
            <div className="col-lg-5 text-white p-5 d-flex flex-column justify-content-between position-relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0f2b5b 0%, #1a4185 100%)' }}>
              
              {/* Background Decorative Pattern */}
              <div className="position-absolute top-0 end-0 opacity-10 pe-none" style={{ transform: 'translate(20%, -20%) scale(2)' }}>
                <svg width="200" height="200" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
              </div>

              <div className="position-relative z-1">
                <h3 className="h2 fw-bolder mb-3 text-white">Get in Touch</h3>
                <p className="text-white-50 mb-5" style={{ fontSize: '1.1rem' }}>Have questions about our solar manufacturing or custom power solutions? We'd love to hear from you.</p>
                
                <div className="d-flex flex-column gap-4">
                  {/* Location Icon & Text */}
                  <div className="d-flex align-items-start gap-4">
                    <div className="bg-warning rounded-circle p-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0" style={{ width: '50px', height: '50px' }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0f2b5b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1 text-warning text-uppercase" style={{ fontSize: '12px', letterSpacing: '1px' }}>Head Office</h6>
                      <p className="fs-6 mb-0 text-white opacity-75">Sector-11, Indira Nagar,<br />Lucknow - 226016, UP</p>
                    </div>
                  </div>

                  {/* Phone Icon & Text */}
                  <div className="d-flex align-items-center gap-4">
                    <div className="bg-white rounded-circle p-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0" style={{ width: '50px', height: '50px' }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0f2b5b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                      </svg>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1 text-white text-uppercase" style={{ fontSize: '12px', letterSpacing: '1px' }}>Call Us Directly</h6>
                      <p className="mb-0 fw-semibold text-white" style={{ fontSize: '1.05rem' }}>+91 9906044032 <br /> +91 9260917766</p>
                    </div>
                  </div>

                  {/* Email Icon & Text */}
                  <div className="d-flex align-items-center gap-4">
                    <div className="bg-white rounded-circle p-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0" style={{ width: '50px', height: '50px' }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0f2b5b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1 text-white text-uppercase" style={{ fontSize: '12px', letterSpacing: '1px' }}>Email Address</h6>
                      <p className="fs-6 mb-0 text-white" style={{ wordBreak: 'break-all' }}>dsesps234@gmail.com</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bottom Trust Info */}
              <div className="mt-5 pt-4 border-top position-relative z-1" style={{ borderColor: 'rgba(255,255,255,0.15) !important' }}>
                <p className="small text-white-50 mb-2"><span className="fw-bolder text-warning tracking-wider">GSTIN:</span> <span className="text-white">09AMQPS5878Q1ZH</span></p>
                <p className="small text-white-50 mb-0"><span className="fw-bolder text-warning tracking-wider">DIRECTOR:</span> <span className="text-white">Shashi Prakash Srivastava</span></p>
              </div>
            </div>

            {/* Contact Form (Right Side) */}
            <div className="col-lg-7 p-5 bg-white d-flex flex-column justify-content-center">
              <h3 className="h2 fw-bolder mb-2" style={{ color: '#0f2b5b' }}>Send us a message</h3>
              <p className="text-muted mb-4">Fill out the form below and our team will get back to you within 24 hours.</p>
              
              <form>
                <div className="row g-4 mb-4">
                  <div className="col-md-6">
                    <label className="form-label fw-bold" style={{ color: '#0f2b5b', fontSize: '14px' }}>Full Name *</label>
                    <input type="text" className="form-control form-control-lg border-1 shadow-none" placeholder="John Doe" style={{ backgroundColor: '#f8fbfc', fontSize: '15px' }} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-bold" style={{ color: '#0f2b5b', fontSize: '14px' }}>Email Address *</label>
                    <input type="email" className="form-control form-control-lg border-1 shadow-none" placeholder="john@example.com" style={{ backgroundColor: '#f8fbfc', fontSize: '15px' }} />
                  </div>
                </div>
                
                <div className="mb-4">
                  <label className="form-label fw-bold" style={{ color: '#0f2b5b', fontSize: '14px' }}>Subject</label>
                  <input type="text" className="form-control form-control-lg border-1 shadow-none" placeholder="How can we help?" style={{ backgroundColor: '#f8fbfc', fontSize: '15px' }} />
                </div>
                
                <div className="mb-4">
                  <label className="form-label fw-bold" style={{ color: '#0f2b5b', fontSize: '14px' }}>Message *</label>
                  <textarea className="form-control form-control-lg border-1 shadow-none" rows="5" placeholder="Write your specific requirements here..." style={{ resize: 'none', backgroundColor: '#f8fbfc', fontSize: '15px' }}></textarea>
                </div>
                
                <button type="button" className="btn btn-warning w-100 py-3 fw-bold border-0 text-dark rounded-3 d-flex align-items-center justify-content-center gap-2 shadow-sm transition-all hover-shadow">
                  Send Message
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                </button>
              </form>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
}